import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone:false,
  name: 'cidr'
})
export class CidrPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    var values:string[];
    try {
      values = value.split(",");
    } catch (error) {
      values = value;
    }
    return values.map(val => {
      if(val === "") return "Not Assigned";
      let prefix = val.split("/")[0];
      let suffix = val.split("/")[1];
      if(suffix === "24") return prefix;
      if(suffix === "64") return prefix;
      return val;
    })
  }

}
